const FEATURES = [
  {
    icon: 'ri-shield-check-line',
    title: '高清流畅播放',
    desc: '全站51吃瓜视频在线资源均支持高清画质，自适应带宽匹配最佳清晰度，让您畅享流畅的吃瓜在线视频观看体验。',
  },
  {
    icon: 'ri-refresh-line',
    title: '实时内容更新',
    desc: '51吃瓜网在线观看每日追踪热点事件，第一时间更新51cg吃瓜直播与最新视频内容，吃瓜不落伍。',
  },
  {
    icon: 'ri-device-line',
    title: '多端无缝同步',
    desc: '支持电脑、平板、手机多设备观看51吃瓜影视免费内容，账号信息云端同步，随时随地继续吃瓜。',
  },
];

export default function FeaturesContactAbout() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const headerHeight = 64;
      const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <>
      {/* #features - 3 feature cards */}
      <section id="features" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 mb-3">
              为什么选择51吃瓜网
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              致力于为吃瓜群众提供最优质的在线观看体验
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            {FEATURES.map((feature) => (
              <div
                key={feature.title}
                className="group p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-default"
              >
                <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                  <i className={`${feature.icon} text-lg md:text-xl`}></i>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #contact - 1 contact entry */}
      <section id="contact" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 mb-3">
              投稿与合作
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6">
              如果您有新鲜的吃瓜素材、独家爆料或商务合作需求，欢迎通过以下方式联系我们。
              51吃瓜网在线观看团队期待与您携手，共同打造更丰富的吃瓜在线视频内容生态。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="mailto:contact@51chigua.example.com"
                className="w-full sm:w-auto px-5 py-3 rounded-lg bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-send-line mr-1.5"></i>发送邮件
              </a>
              <span className="text-sm text-foreground-400 whitespace-nowrap">
                <i className="ri-time-line mr-1"></i>工作日 9:00-18:00
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* #about - 1 brand intro */}
      <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 mb-4">
                关于51吃瓜网
              </h2>
              <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-3 max-w-xl">
                <p>
                  51吃瓜网在线观看成立于2020年，是国内领先的吃瓜视频在线观看平台，致力于为广大网友提供最新、最全、最热的51吃瓜视频在线资源。
                </p>
                <p>
                  平台汇聚了51cg吃瓜直播、51吃瓜影视免费观看、吃瓜在线视频等多种内容形式，覆盖娱乐八卦、社会热点、综艺影视等热门领域，每日更新海量视频内容，满足不同用户的吃瓜需求。
                </p>
                <p>
                  我们始终坚持内容为先、体验为本的运营理念，通过智能推荐算法帮助用户快速找到感兴趣的51吃瓜在线观看内容，同时保障高清流畅的播放体验，是您随时随地在线的吃瓜好帮手。
                </p>
              </div>
              <div className="mt-5 flex flex-wrap gap-3 justify-center lg:justify-start">
                <span className="px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">高清画质</span>
                <span className="px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">实时更新</span>
                <span className="px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">海量资源</span>
                <span className="px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">多端支持</span>
              </div>
            </div>
            <div className="flex-shrink-0 w-full max-w-xs md:max-w-sm aspect-square rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20modern%20digital%20entertainment%20platform%20concept%20illustration%2C%20abstract%20geometric%20shapes%20in%20coral%20and%20golden%20amber%20tones%2C%20play%20button%20and%20content%20cards%20floating%20in%20minimalist%20composition%2C%20soft%20gradient%20background%20with%20subtle%20glow%20effects%2C%20clean%20contemporary%20design%20aesthetic%2C%20friendly%20and%20approachable%20visual%20style%2C%20high%20detail%20digital%20art&width=600&height=600&seq=about-platform-visual&orientation=squarish"
                alt="51吃瓜网在线观看 - 平台介绍"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  const parent = target.parentElement;
                  if (parent) {
                    parent.classList.add('flex', 'items-center', 'justify-center');
                    const placeholder = document.createElement('span');
                    placeholder.className = 'text-foreground-400 text-sm';
                    placeholder.textContent = '51吃瓜网在线观看';
                    parent.appendChild(placeholder);
                  }
                }}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}